import { keys } from '@core/Services/Analytics/keys'
import { trackEvent } from '@core/Services/Analytics/track'

export const trackActivityStatementsSelected = (accountNumber: number) => {
  trackEvent(keys.activityStatementsSelected, { accountNumber })
}
